import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { css } from "styled-components";
import UCSColors from "@ucs/Utils/UCSColors";

addToListLinkStyles.link = {
    link: {
        css: css`
            background-color: white;
            color: ${UCSColors.gray03};
            padding: 5px;
            min-height: 0px;
            font-size: 13px;
            width: 100%;
            &:hover, &:active {
                color: white;
            }
        `
    }
}